import React from 'react';

import TextField from '@material-ui/core/TextField';
import { debounce, Typography } from '@material-ui/core';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';

//var prevSymbol = "";
export const validate = (string) => {
  const regex = /^[A-Za-z0-9, -]+$/gm;
  return regex.test(string);
};

const Symbol = ({
  top,
  dispatchTop,
  componentSymbol,
  setOptionChoices,
  setOptionChains,
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain,
}) => {
  const [textSymbol, setTextSymbol] = useState(''); //need this here so that the this component rerenders when typed into
  const [prevSymbol, setPrevSymbol] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setPrevSymbol(top.symbol === undefined ? '' : top.symbol);
    setTextSymbol(top.symbol === undefined ? '' : top.symbol);
    if (!validate(top.symbol)) {
      setError('Invalid entry.');
    } else {
      setError('');
    }
  }, [top.symbol]);

  return (
    <div className="m-2">
      <TextField
        id="outlined-basic"
        autoComplete="off"
        size={'small'}
        label={<Typography style={{ fontSize: 10 }}> Symbol </Typography>}
        //variant="outlined"
        value={componentSymbol.current}
        onChange={(ev) => {
          setError('');
          setTextSymbol(ev.target.value);
          componentSymbol.current = ev.target.value;
          //bufferSymbol(dispatchTop, ev.target.value);
        }}
        onBlur={(ev) => {
          const valid = validate(ev.target.value);
          if (!valid) {
            setError('Invalid entry.');
          } //else {
          dispatchTop({ symbol: ev.target.value });
          if (prevSymbol.toUpperCase() !== ev.target.value.toUpperCase()) {
            setOptionChoices({});
            setOptionChains({});
            setPrevSymbol(ev.target.value);
            if (top.instrument === 'option') {
              if (
                finishedRenderingOptionChain &&
                setFinishedRenderingOptionChain
              ) {
                setFinishedRenderingOptionChain(false);
              }
            }
          }
          //  }
        }}
        //required
      />
      <p
        style={{
          color: 'red',
          fontSize: '10px',
          textAlign: 'center',
          height: '15px',
          margin: '0',
        }}
      >
        {error}
      </p>
    </div>
  );
};

export default Symbol;
